import gql from 'graphql-tag';

const query = gql`
  mutation requestAppointment($params: RequestParams!) {
    requestAppointment(params: $params)
  }
`;
export default query;
